import { Action } from 'redux';
import { MedigapEligibilityCheckStateStructure } from '../../angular-elements/shared/interfaces/medigapEligibilityCheckStateStructure.interface';

export class PayloadAction implements Action {
  type: string;
  medigapEligibilityStateStructure?: MedigapEligibilityCheckStateStructure;
}

const INITIAL_STATE: MedigapEligibilityCheckStateStructure = {
  enrolledInMedicareBefore65: '',
  guaranteedAcceptance: '',
  guaranteedIssue: '',
  enrolledInNonMedigapBlue: '',
  initialEntryDate: '',
  medigapApplication: '',
  medigapQualification: '',
  upgradeCurrentCoverage: '',
  within6MonthsOfAge65: '',
  within6MonthsOfPartBEnrollment: ''
};

export const LOAD_MEDIGAP_ELIGIBILITY_INFO = 'LOAD_MEDIGAP_ELIGIBILITY_INFO';
export const INIT_PAYLOAD = 'INIT_PAYLOAD';
const RESET_STATE = 'RESET_STATE_MedigapEligibilityCheck';

export function loadMedigapEligibilityInfo(info: MedigapEligibilityCheckStateStructure): PayloadAction {
  return {
    type: LOAD_MEDIGAP_ELIGIBILITY_INFO,
    medigapEligibilityStateStructure: info
  };
}

export function resetMedigapEligibilityCheck(): PayloadAction {
  return { type: RESET_STATE };
}

export function medigapEligibilityCheck( state: MedigapEligibilityCheckStateStructure = INITIAL_STATE, action: PayloadAction ) {
  const copiedState = JSON.parse(JSON.stringify(Object.assign({}, state)));
  switch (action.type) {
    case LOAD_MEDIGAP_ELIGIBILITY_INFO:
      copiedState.enrolledInMedicareBefore65 = action.medigapEligibilityStateStructure.enrolledInMedicareBefore65;
      copiedState.guaranteedAcceptance = action.medigapEligibilityStateStructure.guaranteedAcceptance;
      copiedState.guaranteedIssue = action.medigapEligibilityStateStructure.guaranteedIssue;
      copiedState.enrolledInNonMedigapBlue = action.medigapEligibilityStateStructure.enrolledInNonMedigapBlue;
      copiedState.initialEntryDate = action.medigapEligibilityStateStructure.initialEntryDate;
      copiedState.medigapApplication = action.medigapEligibilityStateStructure.medigapApplication;
      copiedState.medigapQualification = action.medigapEligibilityStateStructure.medigapQualification;
      copiedState.upgradeCurrentCoverage = action.medigapEligibilityStateStructure.upgradeCurrentCoverage;
      copiedState.within6MonthsOfAge65 = action.medigapEligibilityStateStructure.within6MonthsOfAge65;
      copiedState.within6MonthsOfPartBEnrollment = action.medigapEligibilityStateStructure.within6MonthsOfPartBEnrollment;
      return Object.assign({}, state, copiedState);
    case RESET_STATE:
      return INITIAL_STATE;
    case INIT_PAYLOAD:
    default:
      return state;
  }
}

